export default {
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
  flexShrink: 0,
  borderStyle: 'solid',
  borderWidth: 0,
  position: 'relative',
  zIndex: 0,
  minHeight: 0,
  minWidth: 0
};
//# sourceMappingURL=defaultStyles.js.map